import { render, staticRenderFns } from "./summary-table.vue?vue&type=template&id=294b7f89&scoped=true"
import script from "./summary-table.vue?vue&type=script&lang=js"
export * from "./summary-table.vue?vue&type=script&lang=js"
import style0 from "./summary-table.vue?vue&type=style&index=0&id=294b7f89&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "294b7f89",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/jenkins/data/workspace/KCC_AUDIT_PROD_Frontend/node_modules/vue-loader/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('294b7f89')) {
      api.createRecord('294b7f89', component.options)
    } else {
      api.reload('294b7f89', component.options)
    }
    module.hot.accept("./summary-table.vue?vue&type=template&id=294b7f89&scoped=true", function () {
      api.rerender('294b7f89', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/client-view/groupReporting/summary-table.vue"
export default component.exports